interface ProjectInfo {
  image: string;
  title: string;
  subtitle: string;
  about: string;
  url: string;
  role: string;
  tools: string[];
  images: string[];
  did: string;
}
interface ProjectImage {
  firstBanner: string;
  secondBanner: string;
  thirdBanner: string;
  firstMobile: string;
  subtitle: string;
  secondMobile: string;
}

export const ProjectData: Array<ProjectInfo> = [
  {
    image: "/images/skeep/banner-1.png",
    title: "Skeep AI",
    subtitle: "skeep",
    about:
      "Logistics and food aggregation platform connecting customers, vendors, and riders.",
    url: "https://useskeep.com/",
    role: "A",
    tools: [
      "next.js,",
      "react native,",
      "tailwind css,",
      "typescript,",
      "nodejs",
    ],
    images: [
      "/images/skeep/banner-1.png",
      "/images/skeep/banner-2.png",
      "/images/skeep/mobile-1.jpg",
      "/images/skeep/mobile-2.PNG",
    ],
    did: "Skeep AI is a logistics and food aggregation platform that connects customers, vendors, and riders through web and mobile applications. The platform supports food ordering, vendor operations, delivery management, real-time tracking, and related logistics workflows across its ecosystem.",
  },
  {
    image: "/images/ruto/banner-1.png",
    title: "Ruto Wallet",
    subtitle: "ruto",
    about:
      "Digital wallet platform for cryptocurrency transactions and financial services.",
    url: "https://rutowallet.com",
    role: "B",
    tools: ["apache cordova,", "react,", "tailwind css,", "typescript"],
    images: [
      "/images/ruto/banner-1.png",
      "/images/ruto/banner-2.png",
      "/images/ruto/banner-3.png",
      "/images/ruto/mobile-1.jpg",
      "/images/ruto/mobile-2.jpg",
    ],
    did: "Ruto Wallet is a digital wallet platform focused on cryptocurrency transactions and financial services. It provides users with tools for managing digital assets, viewing balances and transaction activity, and carrying out secure financial operations through a web-based interface.",
  },
  {
    image: "/images/seemax.png",
    title: "seemax",
    subtitle: "seemax",
    about:
      "Website to check the latest movie releases, search through popular choices and watch trailers.",
    url: "https://seemax.vercel.app",
    role: "C",
    tools: ["reactjs,", "tailwind css,", "context api"],
    images: [
      "/images/seemax.png",
      "/images/seemax/banner2.png",
      "/images/seemax/banner1.png",
    ],
    did: "",
  },
  {
    image: "/images/bato.png",
    title: "Bato Footwears",
    subtitle: "bato",

    about: "An ecommerce website for a shoemaker client.",
    url: "",
    role: "D",
    tools: ["vite + reactjs,", "tailwind css,", "context api"],
    images: [],
    did: "",
  },
  {
    image: "/images/rent-soft.png",
    title: "Rent-Soft",
    subtitle: "rent-soft",

    about: "A website for renting apartments online.",
    url: "",
    role: "E",
    tools: ["reactjs,", "tailwind css,", "redux", "mongodb", "nodejs"],
    images: [],
    did: "",
  },
  {
    image: "/images/octodos.png",
    title: "octodos",
    subtitle: "octodos",
    about:
      "A Nigerian tech agency that builds software and handles projects for people.",
    url: "https://octodos.vercel.app",
    role: "F",
    tools: ["vuejs,", "tailwind css,", "gsap"],
    images: [],
    did: "",
  },
  {
    image: "/images/fgms.png",
    title: "Firdaus-Gate Model Schools",
    subtitle: "fgms",
    about: "School webiste built for Firdaus-Gate Model Schools.",
    url: "https://firdausgateschools.com",
    role: "G",
    tools: [
      "javascript,",
      "reactjs,",
      "nodejs,",
      "bootstrap css,",
      "redux",
      "mongodb,",
    ],
    images: [
      "/images/ferinstore/seemax3.png",
      "/images/ferinstore/seemax2.png",
      "/images/ferinstore/seemax2.png",
    ],
    did: "Fully designed and launched the school's website, ensuring a user-friendly and responsive interface. Implemented SEO best practices to enhance search engine visibility.",
  },

  {
    image: "/images/ferinco.png",
    title: "Ferinco's Portfolio Website",
    subtitle: "ferinco",
    about: "A portfolio website built for myself.",
    url: "https://emmanuelferinco.vercel.app",
    role: "H",
    tools: ["typescript,", "tailwind css,", "context api"],
    images: [],
    did: "",
  },
  {
    image: "/images/ferinstore.png",
    title: "clothify",
    subtitle: "clothify",
    about: "An online fashion store",
    url: "",
    role: "I",
    tools: ["reactjs,", "bootstrap css,", "context api"],
    images: [
      "/images/ferinstore.png",
      "/images/ferinstore/banner3.png",
      "/images/ferinstore/banner1.png",
      "/images/ferinstore/banner2.png",
    ],
    did: "",
  },
];

export const ProjectImages: Array<ProjectImage> = [
  {
    firstBanner: "/images/skeep/banner-1.png",
    secondBanner: "/images/skeep/banner-2.png",
    thirdBanner: "/images/skeep/banner-2.png",
    firstMobile: "/images/skeep/mobile-1.jpg",
    secondMobile: "/images/skeep/mobile-2.PNG",
    subtitle: "skeep",
  },
  {
    firstBanner: "/images/ruto/banner-1.png",
    secondBanner: "/images/ruto/banner-2.png",
    thirdBanner: "/images/ruto/banner-3.png",
    firstMobile: "/images/ruto/mobile-1.jpg",
    secondMobile: "/images/ruto/mobile-2.jpg",
    subtitle: "ruto",
  },
  {
    firstBanner: "/images/ferinstore/banner3.png",
    secondBanner: "/images/ferinstore/banner2.png",
    thirdBanner: "/images/ferinstore/banner2.png",
    secondMobile: "/images/ferinstore/mobile2.png",
    firstMobile: "/images/ferinstore/mobile1.png",
    subtitle: "clothify",
  },
  {
    firstBanner: "/images/seemax/banner1.png",
    secondBanner: "/images/seemax/banner2.png",
    thirdBanner: "/images/ferinstore/banner2.png",
    firstMobile: "/images/seemax/mobile1.png",

    secondMobile: "/images/seemax/mobile2.png",
    subtitle: "seemax",
  },
  {
    firstBanner: "/images/ferinstore.png",
    secondBanner: "",
    thirdBanner: "/images/ferinstore/banner2.png",
    firstMobile: "",

    secondMobile: "",
    subtitle: "ferinco",
  },
  {
    firstBanner: "/images/fgms/banner1.png",
    secondBanner: "/images/fgms/banner2.png",
    thirdBanner: "/images/ferinstore/banner2.png",

    firstMobile: "/images/fgms/mobile1.png",
    secondMobile: "/images/fgms/mobile2.png",
    subtitle: "fgms",
  },
];
